/**
 * ForecastPageStates — extraído de ForecastPage.tsx (P7 split).
 *
 * Componentes para los early-returns de loading/error de ForecastPage.
 * Comparten el mismo header (icono + título "Forecast de Compras") y
 * difieren solo en el body (CircularProgress vs Alert).
 */

import {
  Alert,
  Box,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { Insights as ForecastIcon } from "@mui/icons-material";

export function ForecastPageLoading(): React.ReactElement {
  return (
    <Box>
      <Stack spacing={3}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <ForecastIcon color="primary" />
          <Typography variant="h4" component="h1" fontWeight={600}>
            Forecast de Compras
          </Typography>
        </Stack>
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{ minHeight: "400px" }}
        >
          <CircularProgress size={48} />
          <Typography variant="body1" sx={{ mt: 2 }}>
            Cargando productos...
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}

export function ForecastPageError({
  message,
}: {
  message: string;
}): React.ReactElement {
  return (
    <Box>
      <Stack spacing={3}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <ForecastIcon color="primary" />
          <Typography variant="h4" component="h1" fontWeight={600}>
            Forecast de Compras
          </Typography>
        </Stack>
        <Alert severity="error" sx={{ mb: 2 }}>
          {message}
        </Alert>
      </Stack>
    </Box>
  );
}
